import { useStore } from 'vuex';

export const useAiChatWidget = () => {
  const bubbleState = ref('closed');

  const store = useStore();
  const { featureFlags } = store?.state || {};


  const loadDrawer = ref(false);   // Handles internal lazy loading of the drawer, so that the drawer is not loaded until the user hovers over the bubble.
  // Handles internal lazy loading of the drawer, so that the drawer is not loaded until the user hovers over the bubble.
  const handleFirstHover = () => {
    loadDrawer.value = true;
  }
  
  const getFeatureFlag = (flagName: string): boolean => {
    return featureFlags?.[flagName] ?? false;
  };

  const aiChatEnabled = computed(() => getFeatureFlag('cms_ai_chat'));
  const aiContactFormEnabled = computed(() => getFeatureFlag('cms_contact_form'));

  const handleStateChange = (state: string) => {
    bubbleState.value = state;
  };

  const handleDrawerClose = () => {
    bubbleState.value = 'closed';
  }

  const isOpen = computed(() => {
    return bubbleState.value !== 'closed';
  });

  return {
    bubbleState,
    aiChatEnabled,
    aiContactFormEnabled,
    isOpen,
    loadDrawer,
    handleStateChange,
    handleDrawerClose,
    handleFirstHover
  };
};
